// import { cloneDeep } from 'lodash'

const DEFAULT_STATE = {}

export const reportsReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case 'UPDATE_STATE': {
      return {
        ...state,
        ...action.request.state
      }
    }
    case 'UPDATE_REPORT_STATE': {
      const reportState = { ...(state[action.request.id] || {}) }
      if (Object.hasOwn(action.request, 'status')) {
        if (null !== action.request.status) reportState.status = action.request.status
        else delete reportState.status
      }
      if (Object.hasOwn(action.request, 'process')) {
        if (null !== action.request.process) reportState.process = action.request.process
        else delete reportState.process
      }
      return {
        ...state,
        [action.request.id]: reportState
      }
    }
    default:
      throw new Error('Unknown action type')
  }
}
